// src/store/dashboardSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  driver: {
    name: 'Jon Williams',
    email: 'jonwilliams56@gmail.com',
    avatarUrl: '/images/avatar.png', // put a dummy image in public/images
    car: {
      model: 'Volvo XC40',
      rating: 4,
      mileage: '82,986 km',
      battery: '3 to 42%',
      time: '220V'
    },
    stats: [
      { label: 'Mileage', value: '82,986 km' },
      { label: 'Battery', value: '3–42%' },
      { label: 'Time',    value: '220V' }
    ]
  },
  totals: {
    passengers: { value: 10968, change: 13.8, data: [45,52,48,61,55,67,73,89,76,85,92,78] },
    trips     : { value: 7600,  change: 12.9, data: [32,41,35,48,42,55,61,58,65,62,70,68] }
  },
  tripsList: [
    { id:1, passenger:'Ollie Nora',   date:'Wed, 18 Dec 2024', status:'Active',    amount:'$32.52', avatar:'/images/p1.jpg' },
    { id:2, passenger:'Jack Jakob',   date:'Wed, 18 Dec 2024', status:'Active',    amount:'$20.96', avatar:'/images/p2.jpg' },
    { id:3, passenger:'Mirella Wms',  date:'Tue, 17 Dec 2024', status:'Completed', amount:'$2200.52', avatar:'/images/p3.jpg' },
    /* … */
  ],
  income: {
    period: 'Week',
    data: [0,1200,800,1500,2567,400,600]
  }
};

const slice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setIncomePeriod(state, action) {
      state.income.period = action.payload;
    }
  }
});

export const { setIncomePeriod } = slice.actions;
export default slice.reducer;
